import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {BedAvailableDto, BedModel, GetPaginationBedDto} from '../model/bed.model'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getBedsService(dto: GetPaginationBedDto) {
  return axios.post<ResponseObjectPaginated<BedModel[]>>(`${BASEURL}/bed/getList`, dto)
}

export function getBedsAvailableService(dto: BedAvailableDto) {
  return axios.post<ResponseObjectPaginated<BedModel[]>>(`${BASEURL}/bed/getListAvailable`, dto)
}

export function getListBedsExcelService(dto: any) {
  return axios.post<any>(`${BASEURL}/bed/getListExcel`, dto, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'arraybuffer',
  })
}

export function getTemplateBedService() {
  return axios.post<any>(
    `${BASEURL}/bed/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}
